<template>
    <px-kintai-csv-form />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import PxKintaiCsvForm from '@/components/px/kintaicsv/Form.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'px-kintai-csv-form': PxKintaiCsvForm
    }
})
</script>
